export default __webpack_public_path__ + "static/media/vfwlogo.e38c9c5c.png";